import { useEffect } from "react";
import { setCountry, useDispatch } from "@jti/store";
import { useCountry } from "@jti/ui";
export const CountrySetter = () => {
    const dispatch = useDispatch();
    const country = useCountry();
    useEffect(() => {
        dispatch(setCountry(country));
    }, [country]);
    return null;
};
//# sourceMappingURL=CountrySetter.js.map